import { render } from "./SkiSchoolUpdate.vue?vue&type=template&id=737a50fc&scoped=true"
import script from "./SkiSchoolUpdate.vue?vue&type=script&lang=js"
export * from "./SkiSchoolUpdate.vue?vue&type=script&lang=js"

import "./SkiSchoolUpdate.vue?vue&type=style&index=0&id=737a50fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737a50fc"]])

export default __exports__